import { createSlice } from '@reduxjs/toolkit';
import { VerifyState } from '../types/state';

export const initialState: VerifyState = {
  showResendLink: false,
};

export const verifySlice: any = createSlice({
  name: 'verify',
  initialState,
  reducers: {
    setShowResendLink: (state, action) => {
      state.showResendLink = action.payload;
    },
  },
});

export const { setShowResendLink } = verifySlice.actions;

export default verifySlice.reducer;
